import React from 'react';

const Testimonials = () => {
  const testimonials = [
    {
      name: "Ndibuho V.",
      rating: 5,
      comment:
        "I have had the greatest experience 🥹 from start to end, perfection😭✋🏽!!! It's been a month and 2 days and I still have the majority of my lashes on and THAT’S ON RETENTION👌🏾",
      service: "Lash Extensions",
      date: "14 Sept 2025"
    },
    {
      name: "Ntebo T.",
      rating: 5,
      comment:
        "The owner is so lovely, very kind and welcoming. Excellent service I will definitely be going back!",
      service: "Salon Service",
      date: "03 Aug 2025"
    },
    {
      name: "Phathutshedzo N.",
      rating: 5,
      comment:
        "Amazing experience at Zoteya Beauty! The team is professional and the results are always perfect. Highly recommend!",
      service: "Hair Service",
      date: "24 Sept 2025"
    },
    {
      name: "Ntloko L.",
      rating: 5,
      comment:
        "Exceptional service and quality! The stylists truly understand what I need and always deliver beyond my expectations.",
      service: "Styling",
      date: "22 Aug 2025"
    },
    {
      name: "Sarah L.",
      rating: 5,
      comment:
        "Absolutely love the results! My hair has never looked better. The stylists are true artists and the products are amazing.",
      service: "Haircut & Coloring"
    },
    {
      name: "Jessica M.",
      rating: 5,
      comment:
        "Incredible service and attention to detail. The heat protectant spray saved my hair from damage. Highly recommend!",
      service: "Styling & Products"
    }
  ];

  // Stars with gold accent
  const renderStars = (rating) => (
    <div className="d-flex gap-1 mb-1" style={{ fontSize: "0.99rem", justifyContent: "center" }}>
      {[...Array(5)].map((_, i) => (
        <span
          key={i}
          className={`fw-bold ${i < rating ? 'text-warning' : 'text-muted'}`}
          style={{ fontSize: "1em" }}
        >★</span>
      ))}
    </div>
  );

  return (
    <section id="testimonials" className="py-5" style={{ background: 'linear-gradient(180deg, #fff, #f7f4ec 94%)' }}>
      <div className="container pb-1">
        <div className="text-center mb-2">
          <span
            className="badge rounded-pill px-3 py-1 mb-2"
            style={{
              background: '#f7ecd2',
              color: '#8b7355',
              letterSpacing: '.09em',
              fontWeight: 600,
              fontSize: '.93rem',
              border: '1.2px solid #d4c4a8'
            }}
          >Testimonials</span>
          <h2 className="fw-bold mb-1" style={{
            fontFamily: "'Playfair Display', serif",
            color: '#3a3a3a',
            letterSpacing: '.012em',
            fontSize: "1.15rem"
          }}>What Our Clients Say</h2>
          <p className="text-muted mx-auto mb-0" style={{ maxWidth: 410, fontSize: ".97em" }}>
            Real experiences from our valued clients at Zoteya Beauty
          </p>
        </div>
        <div
          className="row g-2 justify-content-center"
          style={{ rowGap: '0.7rem', columnGap: '0.95rem' }}
        >
          {testimonials.map((testimonial, idx) => (
            <div
              className="col-6 col-md-4 col-lg-3 d-flex flex-column align-items-center"
              key={idx}
              style={{
                minWidth: 145,
                maxWidth: 190,
                margin: "0 auto",
                padding: 0
              }}
            >
              <div
                className="w-100"
                style={{
                  background: '#fff',
                  borderRadius: 8,
                  boxShadow: "0 2px 7px #cab38a19",
                  padding: "0.7rem 0.65rem 0.5rem 0.65rem",
                  height: '100%',
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "stretch",
                  transition: "box-shadow .12s,transform .12s",
                  position: "relative"
                }}
              >
                <span
                  className="position-absolute"
                  style={{
                    top: 10,
                    right: 15,
                    fontSize: "1.35rem",
                    color: "#e2dabf",
                    opacity: 0.67,
                    pointerEvents: "none",
                    zIndex: 1
                  }}
                  aria-hidden="true"
                >“</span>
                <div style={{ zIndex: 2, position: 'relative' }}>
                  {renderStars(testimonial.rating)}
                  <blockquote
                    className="card-text text-secondary fst-italic"
                    style={{
                      fontSize: ".98em",
                      lineHeight: "1.4",
                      marginBottom: 16,
                      minHeight: 42,
                      maxHeight: 60,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      textAlign: "center"
                    }}>
                    "{testimonial.comment}"
                  </blockquote>
                  <div style={{
                    borderTop: "1px solid #ebdbbf",
                    paddingTop: 7,
                    marginTop: 5,
                    fontSize: ".94em"
                  }}>
                    <div className="fw-bold" style={{
                      color: "#423509",
                      fontSize: ".99em"
                    }}>
                      {testimonial.name}
                    </div>
                    <div className="text-warning small" style={{
                      fontWeight: 600,
                      fontSize: ".92em"
                    }}>
                      {testimonial.service}
                    </div>
                    {testimonial.date &&
                      <div className="text-muted small"
                        style={{ fontSize: ".9em" }}>{testimonial.date}</div>
                    }
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
